module.exports = __webpack_public_path__ + "static/media/400011_02.97f90dff.png";